import { Model, attr } from 'redux-orm';
import {
  createAction,
  createAddConst,
  createDeleteConst,
  createLoadConst,
  createRequestConst,
  createUpdateConst,
} from '../util';

export default class PalIfpEnrolled extends Model {
  static get modelName() {
    return 'PalIfpEnrolled';
  }

  static reducer({ type, data }, PalIfpEnrolled) {
    switch (type) {
      case LOAD.SUCCESS:
        PalIfpEnrolled.delete();
        if (data?.response) {
          PalIfpEnrolled.create(data.response);
        }
        break;

      case CREATE.SUCCESS:
        // 202 response — no state to store, saga will reload
        break;

      case UPDATE.SUCCESS:
        // 202 response — no state to store, saga will reload
        break;

      case RECONCILE.SUCCESS:
        // 202 response — no state to store, saga will reload
        break;

      case RESET.SUCCESS:
        PalIfpEnrolled.delete();
        break;

      case CLEAR_ERROR.ACTION: {
        const record = PalIfpEnrolled.first();
        if (record) {
          record.set('lastError', null);
        }
        break;
      }

      case LOAD.FAILURE:
        PalIfpEnrolled.delete();
        break;

      default:
        break;
    }
  }

  static get fields() {
    return {
      id: attr(),
      fspId: attr(),
      enrollmentStatus: attr(),
      desiredVersion: attr(),
      appliedVersion: attr(),
      desired: attr(),
      observed: attr(),
      lastError: attr(),
    };
  }
}

const name = PalIfpEnrolled.modelName;

export const CLEAR_ERROR = { ACTION: `${name}/CLEAR_ERROR` };
export const CREATE = createAddConst(name);
export const LOAD = createLoadConst(name);
export const RECONCILE = createRequestConst(name);
export const RESET = createDeleteConst(name);
export const UPDATE = createUpdateConst(name);

export const clearError = () => ({ type: CLEAR_ERROR.ACTION });
export const create = createAction(CREATE);
export const load = createAction(LOAD);
export const reconcile = createAction(RECONCILE);
export const reset = createAction(RESET);
export const update = createAction(UPDATE);
